export default "__VITE_ASSET__4b0de2aa__"